import { Filter } from './filter.model';

export const FAVORITE_VIEW_DEFAULT_COLOR = '#4F78B7';
export const FAVORITE_VIEW_COLORS = ['#ADCAFA', '#76A9FF', '#4F78B7', '#7C6DB0', '#A05E9D', '#AF568D', '#A5ABBB', '#D1A33E', '#AB6439', '#5A9D98', '#4E8683'];

export enum FavoriteViewReportStatus {
  DISABLED = 'disabled',
  ACTIVE = 'active'
}

export interface FavoriteViewSubscriber {
  id: string;
  email: string;
  firstname: string;
  lastname: string;
}

export interface FavoriteViewExport {
  status: FavoriteViewReportStatus;
  lastRun: string | null;
  nextRun: string | null;
  cron: string | null;
  subscribers: FavoriteViewSubscriber[];
}

export interface FavoriteView {
  id?: string;
  name?: string;
  pinned?: boolean;
  shared?: boolean;
  owner?: string;
  count?: number;
  businessProfileId?: string;
  concept?: string;
  masterView?: string;
  color?: string;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
  filters?: Filter[];
  loading?: boolean;
  description?: string;
  gridId?: string | null;
  export?: FavoriteViewExport;
}
